var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurgerMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000d9",
    fillRule: "evenodd",
    d: "M0 2h27.8V0H0v2zm0 11.001h27.8V11H0v2.001zm0 11h27.8v-2H0v2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMobileIcon);
export default __webpack_public_path__ + "static/media/burger-mobile-icon.deb8faf50224e7c596ab177dc637920d.svg";
export { ForwardRef as ReactComponent };